/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, ViewChild } from "@angular/core";
import {
	ControlContainer,
	ControlValueAccessor,
	FormArray,
	FormControlDirective,
	NG_VALUE_ACCESSOR,
	UntypedFormControl,
	ValidationErrors
} from "@angular/forms";
import { CheckboxDetailsOptions } from "./types";

@Component({
	selector: "app-checkbox-details",
	templateUrl: "./checkbox-details.component.html",
	styleUrls: ["./checkbox-details.component.scss"],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: CheckboxDetailsComponent,
			multi: true
		}
	],
	standalone: false
})
export class CheckboxDetailsComponent implements ControlValueAccessor {
	@ViewChild(FormControlDirective, { static: true })
	formControlDirective!: FormControlDirective;

	@Input()
	formControlName: string | number = 0;

	@Input()
	options!: CheckboxDetailsOptions;

	@Input()
	id: string | number = "";

	@Input()
	showErrors = false;

	@Input()
	showCollapseButton = true;

	constructor(private controlContainer: ControlContainer) {}

	registerOnTouched(fn: any): void {
		this.formControlDirective?.valueAccessor?.registerOnTouched(fn);
	}

	registerOnChange(fn: any): void {
		this.formControlDirective?.valueAccessor?.registerOnChange(fn);
	}

	writeValue(obj: any): void {
		this.formControlDirective?.valueAccessor?.writeValue(obj);
	}

	get idTitle(): string {
		return `title${this.id}`;
	}

	get idCollpase(): string {
		return `collapse${this.id}`;
	}

	get target(): string {
		return `#${this.idCollpase}`;
	}

	get control(): UntypedFormControl | null {
		return (this.controlContainer.control as FormArray).controls
			? ((this.controlContainer.control as FormArray).controls[
					+this.formControlName
				] as UntypedFormControl)
			: (this.controlContainer.control?.get(
					this.formControlName.toString()
				) as UntypedFormControl);
	}

	get errors(): ValidationErrors | null | undefined {
		return this.control?.errors;
	}

	get hasValue(): boolean {
		return Boolean(this.control?.value);
	}

	get isDisabled(): boolean {
		return Boolean(this.control?.disabled);
	}
}
